import rater from '../../../../../assets/vendor/rater-js-master/index';
import Loader from './loader';

export default class Rating {
    constructor($wrapper) {
        this.readOnly = $wrapper.dataset.readOnly == "true";
        this.currentRating = parseInt($wrapper.dataset.currentRating);
        this.objectId = $wrapper.dataset.objectId;
        this.objectTypeId = $wrapper.dataset.objectTypeId;
        this.loader = (new Loader(document.querySelector('[datar-loader]')));

        this.rateCallback = this.rateCallback.bind(this);

        this.rater = rater({
            max:5,
            starSize: 32,
            rating: this.currentRating,
            readOnly: this.readOnly,
            element: $wrapper,
            rateCallback: this.rateCallback
        })
    }

    async rateCallback(rating, done) {

        const result = await this.notifyBackend(rating);

        if (!result['succes'] && !result['auth']) {
            // trigger event to open the login model
            var event = new CustomEvent("open-model", {'detail': {
                    id: 'login-modal',
                }});

            document.dispatchEvent(event);
        }

        if (result['succes'] && result['score']) {
            this.rater.setRating(rating);
            done();
        }
    }

    async notifyBackend(rating) {
        const body = JSON.stringify({
            score: rating,
            objectId: this.objectId,
            objectTypeId: this.objectTypeId
        });

        try {
            const request = await fetch(
                    placeholders.baseUri
                            ? placeholders.baseUri + '/ajax/type/51/processRating'
                            : 'ajax/type/51/processRating'
                    ,
                    {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: body
                    }
            );
            const result = await request.json();
            return result;
        } catch (e) {
            console.log(e);
        }
    }
}